import React, { useState } from 'react'
import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'

export default function HeroSlider({ children }) {
   const [currentSlide, setCurrentSlide] = useState(0)
   const [loaded, setLoaded] = useState(false)
   const [sliderRef, instanceRef] = useKeenSlider(
      {
         loop: true,
         initial: 0,
         slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel)
         },
         created() {
            setLoaded(true)
         },
         slides: {
            origin: 'center',
            perView: 1
         }
      },
      [
         slider => {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
               clearTimeout(timeout)
            }
            function nextTimeout() {
               clearTimeout(timeout)
               if (mouseOver) return
               timeout = setTimeout(() => {
                  slider.next()
               }, 1200)
            }
            slider.on('created', () => {
               nextTimeout()
            })
            slider.on('dragStarted', clearNextTimeout)
            slider.on('animationEnded', nextTimeout)
            slider.on('updated', nextTimeout)
         }
      ]
   )
   return (
      <>
         <div ref={sliderRef} className='keen-slider'>
            {children}
         </div>
         {loaded && instanceRef.current && (
            <div className='dots'>
               {[
                  ...Array(
                     instanceRef.current.track.details.slides.length
                  ).keys()
               ].map(idx => {
                  const isActive = currentSlide === idx;
                  return (
                     <button
                        key={idx}
                        onClick={() => instanceRef.current?.moveToIdx(idx)}
                        className={
                           'dot' + (currentSlide === idx ? ' active' : '')
                        }
                        aria-label={`Go to slide ${idx + 1}`}
                        aria-pressed={isActive}
                     ></button>
                  )
               })}
            </div>
         )}
      </>
   )
}
